module.exports = __webpack_public_path__ + "static/media/forest.9ebb1bc2.jpg";